/**
 * Get the first element in an Iterable (Array, NodeList, Generated function results, etc.).
 * Works just like `lodash/first` but on all iterable, even lazy iterables!
 */
export const first = <E>(it: Iterable<E>): E | undefined => {
    const iterator = it[Symbol.iterator]();
    return iterator.next()?.value;
};
